export default "__VITE_ASSET__BfbLzC83__"